import api from '../../services/api';

export const mediaApi = {
  // Upload files with progress and options
  uploadFiles: async (files, options = {}, onProgress) => {
    const { category = 'general', folderId, compressionQuality = 'medium', optimize = true } = options;
    const formData = new FormData();
    
    if (Array.isArray(files)) {
      files.forEach(file => {
        formData.append('files', file);
      });
    } else {
      formData.append('files', files);
    }
    
    formData.append('category', category);
    formData.append('compressionQuality', compressionQuality);
    formData.append('optimize', optimize.toString());
    if (folderId) formData.append('folderId', folderId);

    const response = await api.post('/media/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: onProgress ? (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        onProgress(percentCompleted);
      } : undefined
    });
    return response.data;
  },

  // Get all media files with advanced filtering
  getAllMedia: async (params = {}) => {
    const { category, folderId, fileType, page = 1, limit = 20, search, sortBy = 'createdAt', sortOrder = 'DESC' } = params;
    const queryParams = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      sortBy,
      sortOrder
    });

    if (category && category !== 'all') queryParams.append('category', category);
    if (folderId) queryParams.append('folderId', folderId);
    if (fileType && fileType !== 'all') queryParams.append('fileType', fileType);
    if (search) queryParams.append('search', search);

    const response = await api.get(`/media?${queryParams}`);
    return response.data;
  },

  // Get media statistics
  getStats: async () => {
    const response = await api.get('/media/stats');
    return response.data;
  },

  // Get CDN status
  getCdnStatus: async () => {
    const response = await api.get('/media/cdn-status');
    return response.data;
  },

  // Get media categories
  getCategories: async () => {
    const response = await api.get('/media/categories');
    return response.data;
  },

  // Update media metadata
  updateMedia: async (id, data) => {
    const response = await api.put(`/media/${id}`, data);
    return response.data;
  },

  // Delete media file
  deleteMedia: async (id) => {
    const response = await api.delete(`/media/${id}`);
    return response.data;
  },

  // Bulk delete media files
  bulkDelete: async (ids) => {
    const response = await api.post('/media/bulk-delete', { ids });
    return response.data;
  },

  // Folder operations
  getAllFolders: async () => {
    const response = await api.get('/media/folders');
    return response.data;
  },

  createFolder: async (data) => {
    const response = await api.post('/media/folders', data);
    return response.data;
  },

  updateFolder: async (id, data) => {
    const response = await api.put(`/media/folders/${id}`, data);
    return response.data;
  },

  deleteFolder: async (id) => {
    const response = await api.delete(`/media/folders/${id}`);
    return response.data;
  },

  // Usage tracking
  trackUsage: async (data) => {
    const response = await api.post('/media/usage/track', data);
    return response.data;
  },

  getMediaUsage: async (id) => {
    const response = await api.get(`/media/usage/${id}`);
    return response.data;
  },

  removeUsage: async (data) => {
    const response = await api.post('/media/usage/remove', data);
    return response.data;
  },

  // Get file URL (supports CDN URLs)
  getFileUrl: (file, thumbnail = false) => {
    // If file has CDN URL, use it
    if (typeof file === 'object' && file.cdnUrl) {
      return file.cdnUrl;
    }
    
    // Otherwise use local URL
    const filename = typeof file === 'string' ? file : file.filename;
    if (thumbnail) {
      return `/api/media/file/${filename}?thumbnail=true`;
    } else {
      return `/api/media/file/${filename}`;
    }
  }
};

export default mediaApi;